import React from 'react'
import { View } from 'react-native'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import NoAppointments from '../../Components/NoAppointments'
import Appointments from '../Appointments/Appointments'

import style from './YourAppointments.Styles'

moment.updateLocale('sq', {
  longDateFormat: {
    LLLL: 'dddd, D MMMM YYYY',
  }
})

moment.updateLocale('en', {
  longDateFormat: {
    LLLL: 'dddd, D MMMM YYYY',
  }
})

const YourAppointments = ({
  appointments,
  isLoading,
  onBookAppointmentsButtonPress,
  formatAppointmentDate,
  isAdmin,
  currentTab,
  ...rest
}) => {

  const insets = useSafeAreaInsets()
  const currentDate = moment()

  const currentAppointments = isLoading ? [{}, {}] : []
  const pastAppointments = isLoading ? [{}, {}] : []

  if (!isLoading) {
    appointments?.map(appointment => {
      const date = moment(appointment?.date?.selectedDate)
      if (currentDate.isAfter(date)) {
        pastAppointments.push(appointment)
      } else {
        currentAppointments.push(appointment)
      }
    })
  }




  const renderCurrentTab = () => {
    return (
      <View style={{ flex: 1 }}>
        {!isLoading && currentAppointments.length === 0 ? <NoAppointments
          onBookAppointmentsButtonPress={onBookAppointmentsButtonPress}
          isAdmin={isAdmin}
        /> : <Appointments
          appointments={currentAppointments}
          isLoading={isLoading}
          onBookAppointmentsButtonPress={onBookAppointmentsButtonPress}
          formatAppointmentDate={formatAppointmentDate}
          currentTab={currentTab}
          {...rest}
        />}
      </View>
    )
  }


  const renderPreviousTab = () => {
    return (
      <View style={{ flex: 1 }}>
        {!isLoading && pastAppointments.length === 0 ? <NoAppointments
          onBookAppointmentsButtonPress={onBookAppointmentsButtonPress}
          isAdmin={isAdmin}
          currentTab={currentTab}
        /> : <Appointments
          appointments={pastAppointments}
          isLoading={isLoading}
          onBookAppointmentsButtonPress={onBookAppointmentsButtonPress}
          formatAppointmentDate={formatAppointmentDate}
          currentTab={currentTab}
          {...rest}
        />}
      </View>
    )
  }


  return (
    <View style={style.container(insets, isLoading)}>
      {currentTab === 0 && renderCurrentTab()}
      {currentTab === 1 && renderPreviousTab()}
    </View>
  )
}

YourAppointments.propTypes = {
  appointments: PropTypes.array,
  isLoading: PropTypes.bool,
  onBookAppointmentsButtonPress: PropTypes.func,
  formatAppointmentDate: PropTypes.func,
  isAdmin: PropTypes.bool
}

export default YourAppointments
